import $ from 'jquery';

import datepicker from 'js-datepicker';
import uk from 'date-fns/locale/uk';
import format from 'date-fns/format';

$(document).ready(function() {
  $('.calc-f').on('change', e => {
    const $this = $(e.currentTarget);
    const roundAttr = $this.attr('data-round');

    let sum = 0;
    let average = 0;
    let result = 0;
    let arrayPrice = [];

    if ($this.val() === '') {
      $(`.round-result[data-round="${roundAttr}"]`).text(0);

      return;
    }

    $('.calc-n').each(function(index, item) {
      if ($(item).val() > 0) {
        arrayPrice.push(item);
        sum += Number($(item).val());
      }
    });

    average = sum / arrayPrice.length;

    $this.val() * 0.70005 > average * 0.60005
      ? (result = $this.val() * 0.70005)
      : (result = average * 0.60005);

    result = Math.round(result);

    if (arrayPrice.length === 0) result = 0;

    $(`.round-result[data-round="${roundAttr}"]`).text(result);
  });

  $('.calc-n').on('change', e => {
    $('.calc-f').each(function(index, item) {
      if ($(item).val() > 0) {
        $(item).trigger('change');
      }
    });
  });

  // added new rival inputs

  let indexRivalItem = 3;

  $('.calculator__subtraction-link').on('click', e => {
    const $this = $(e.currentTarget);
    const rivalList = $('.calculator__rival');

    if ($this.attr('data-subtraction') === 'add-price') {
      indexRivalItem++;

      const newItem = createRivalItem(indexRivalItem);
      rivalList.append(newItem);

      if (indexRivalItem === 10) {
        $(
          ".calculator__subtraction-link[data-subtraction='add-price']"
        ).addClass('hide');
      } else {
        $(
          ".calculator__subtraction-link[data-subtraction='add-price']"
        ).removeClass('hide');
      }
    }

    if (
      $this.attr('data-subtraction') === 'remove-price' &&
      indexRivalItem > 3
    ) {
      const listItem = $(
        `.calculator__rival-item[data-rival-index='${indexRivalItem}']`
      );
      listItem.remove();

      indexRivalItem--;
    }

    if (indexRivalItem === 3) {
      $(
        ".calculator__subtraction-link[data-subtraction='remove-price']"
      ).addClass('hide');
    } else {
      $(
        ".calculator__subtraction-link[data-subtraction='remove-price']"
      ).removeClass('hide');
    }
  });

  function createRivalItem(indexRivalItem) {
    const item = $(
      `<li data-rival-index='${indexRivalItem}' class='calculator__rival-item'><input class='mailing__form-input calc-n' type='number' placeholder='Ціна конкурента №${indexRivalItem}, грн'></li>')`
    );

    return item;
  }

  if ($('.instrument-global-buy__calendar .calendar-input').length === 0) {
    return;
  }

  let picker = datepicker('.instrument-global-buy__calendar .calendar-input', {
    formatter: (input, date, instance) => {
      const formattedDate = format(date, 'dd MMMM, yyyy', {
        locale: uk
      });

      input.value = formattedDate;
    },
    startDay: 1,
    maxDate: new Date(),
    customDays: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    months: [
      'січень',
      'лютий',
      'березень',
      'квітень',
      'травень',
      'червень',
      'липень',
      'серпень',
      'вересень',
      'жовтень',
      'листопад',
      'грудень'
    ],
    onSelect: (instance, date) => {
      let currentYear = date.getFullYear();
      let currentDay = date.getDate();
      let currentMonth = date.getMonth() + 1;

      console.log(date);

      if (currentDay < 10) {
        currentDay = `0${currentDay}`;
      }
      if (currentMonth < 10) {
        currentMonth = `0${currentMonth}`;
      }

      calcGlobalBuySum(`${currentYear}${currentMonth}${currentDay}`);
    }
  });

  if ($('.instrument-global-buy').length > 0) {
    calcGlobalBuySum();
  }

  function calcGlobalBuySum(date = false) {
    let dateForRequest = '',
      currentDate = new Date();

    if (date !== false) {
      dateForRequest = `&date=${date}`;
    } else {
      picker.setDate(new Date());
    }

    let formattedDate = format(currentDate, 'dd MMMM, yyyy', {
      locale: uk
    });

    $.get(
      `https://bank.gov.ua/NBUStatService/v1/statdirectory/exchange?valcode=EUR&json${dateForRequest}`,
      res => {
        let EURtoUAH = res.find(currentVal => currentVal.cc === 'EUR');
        EURtoUAH = Math.floor(EURtoUAH.rate * 100) / 100;
        $('[data-current-currency]').html(`${EURtoUAH} ₴`);

        $('[data-calc-global]').each(function() {
          const $currentTarget = $(this),
            currentEURSum = $currentTarget.find('[data-sum]').attr('data-sum');

          $currentTarget
            .find('[data-total]')
            .html(
              `${(parseInt(currentEURSum) * EURtoUAH).toLocaleString('ru')} ₴`
            );
        });
      }
    );
  }
});
